import { render, staticRenderFns } from "./ListDocumentos.vue?vue&type=template&id=efec4f62&"
import script from "./ListDocumentos.vue?vue&type=script&lang=js&"
export * from "./ListDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./ListDocumentos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports